module.exports = __webpack_public_path__ + "images/fa-ft2024-certificate.webp";